import { formatISO } from 'date-fns';

const isFilled = value => typeof value === 'string' && value.trim().length > 0;

export const selectedCategories = formValues =>
    [formValues.primaryCategory?.[0], ...(formValues.secondaryCategories || []).map(row => row?.category?.[0])].filter(
        category => category?.id,
    );

export const filledServices = formValues =>
    (formValues.services || []).map(service => service?.name?.trim()).filter(isFilled);

const serviceKey = name => name.trim().replace(/\.+$/, '').trim().toLowerCase();

export const unlistedServices = (names, formValues) => {
    const listed = new Set(filledServices(formValues).map(serviceKey));
    return names.filter(name => !listed.has(serviceKey(name)));
};

export const unselectedCategories = (categories, formValues) => {
    const selectedIds = new Set(selectedCategories(formValues).map(category => category.id));
    return categories.filter(category => !selectedIds.has(category.id));
};

export const PLACE_FIELDS = ['country', 'region', 'city'];

export const placeKey = parts => parts.map(part => part || '').join('|');

export const placeOf = formValues => placeKey(PLACE_FIELDS.map(field => formValues[field]));

const specialHourDates = formValues =>
    (formValues.specialHours || [])
        .filter(hour => hour?.date instanceof Date && !Number.isNaN(hour.date.getTime()))
        .map(hour => formatISO(hour.date, { representation: 'date' }));

export const unlistedHolidays = (holidays, formValues) => {
    const listed = new Set(specialHourDates(formValues));
    return holidays.filter(holiday => !listed.has(holiday.date));
};

const DESCRIPTIONS_BY_DETAIL = ['longDescription', 'mediumDescription', 'shortDescription'];

export const buildLocationDraft = (formValues, rewrittenField) => {
    const categories = selectedCategories(formValues);

    return {
        locationName: formValues.locationName || '',
        city: formValues.city || '',
        region: formValues.region || '',
        country: formValues.country || '',
        categories: categories.map(category => category.displayName).filter(isFilled),
        categoryIds: categories.map(category => category.id),
        services: filledServices(formValues),
        description:
            DESCRIPTIONS_BY_DETAIL.filter(field => field !== rewrittenField)
                .map(field => formValues[field])
                .find(isFilled) || '',
        specialHourDates: specialHourDates(formValues),
    };
};
